<template>
  <div class="team-item-container">
    <div class="team-item-avatar" :style="'background-color: ' + avatarColor">
      {{ `${firstName[0]}${lastName[0]}` }}
    </div>
    <div class="team-item-name">
      {{ `${firstName} ${lastName}` }}
    </div>
    <img
      src="@/assets/images/cancel.png"
      class="team-item-remove"
      alt="remove"
      @click="$emit('remove-teammate', userId)"
    />
  </div>
</template>

<script>
export default {
  name: 'TeamItem',
  props: {
    avatarColor: {
      required: true,
      type: String
    },
    firstName: {
      required: true,
      type: String
    },
    lastName: {
      required: true,
      type: String
    },
    userId: {
      required: true,
      type: Number
    }
  }
};
</script>

<style scoped lang="scss">
.team-item-container {
  width: 100%;
  max-width: 590px;
  height: 70px;
  min-height: 70px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 30px;
  border: 1px solid #dfe1e5;
  border-radius: 4px;
  margin-bottom: 5px;
  .team-item-avatar {
    width: 35px;
    height: 35px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    font-weight: 500;
    font-size: 20px;
    line-height: 15px;
    text-align: center;
    letter-spacing: 0.03em;
    color: #ffffff;
  }
  .team-item-name {
    flex: 1;
    font-weight: 500;
    font-size: 24px;
    line-height: 20px;
    letter-spacing: -0.01em;
    margin: 0 15px;
    color: $colorTitle;
  }
  .team-item-remove {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
}
</style>
